import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';

export default function PaginationComponent(props) {
  const {
    count,
    page,
    pageSize,
    pageChange,
    handlePageSizeChange,
    paginationTitle,
  } = props;

  const pageSizeOptions = [3, 5, 10, 20, 50];

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      height="40px"
    >
      <Box display="flex" alignItems="flex-start" height="40px">
        <Pagination
          color="primary"
          count={count}
          page={page}
          onChange={(event, value) => pageChange(event, value)}
          shape="rounded"
        />
      </Box>

      {pageSize && (
        <FormControl style={{ minWidth: '120px' }} size="small">
          {paginationTitle ? (
            <InputLabel id="pagesize-label">{paginationTitle}</InputLabel>
          ) : (
            <InputLabel id="pagesize-label">Cards per page</InputLabel>
          )}
          {/* <InputLabel id="pagesize-label">Cards per page</InputLabel> */}

          <Select
            labelId="pagesize-label"
            label="Cards per page"
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            {pageSizeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}
